
import { Component, Prop, Vue } from "vue-property-decorator";
import Typewriter from "./Typewriter.vue";

@Component({
  components: { Typewriter },
})
export default class Title extends Vue {
  @Prop({default: false})
  isMuted!: boolean;

  sound = localStorage.sound === 'true' ?? false;

  audio = require("@/audio/Main_Theme.mp3")
  text1 = "Sonny Yang's";
  text2 = "Incredibly Inconvenient";
  text3 = "Pandemic Game";

  index = 0;
  event = (e: KeyboardEvent) => {}
  
  mounted() {
    this.event = (e: KeyboardEvent)=> {
  }
  }

  beforeDestroy() {
  }

  next() {
    setTimeout(() => this.index++, 2000);
  }

  done() {
    setTimeout(() => {
      this.$emit("next");
    }, 5000);
  }
}
